/*
 * @Description:
 * @Date: 2024-01-09 14:33:01
 */
// import pcModulePatientSex3Vue from './pc-module-survey-2-3.vue';
// // 患者性别3
// export const pcModulePatientSex3 = pcModulePatientSex3Vue;
const views = (require as any).context(
  './',
  true,
  /pc-module-survey-2-\d{1}\.vue/
);
export default views.keys().map(path => {
  return views(path).default;
});
